import { Box, Button, CircularProgress, Container, Grid, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

let desc = '';
let dia = true;
class ConsultaMovimientos extends Component {
    constructor(props){
        super(props);
        this.state = {

            consulta: false,
            codigosMovimientos: [],
            porMovimiento: false,
            errores: null,
            notificaciones: null,
            consultaRealizada: [],
            lugaresTra: [],
            ubicacionesCentral: [],
            resCodEspecial: false,
            anio: false,
            actual: '',
            tipoEncabezado: '',
            loading: false,

            busqueda: {
                consulta: '',
                numeroFuncionarioBusqueda: '',
                codigo: '',
                ubicacionBusqueda: '',
                desdeBusqueda: '',
                hastaBusqueda: '',
                ubicacionCentral: '',
                codEspeciales: true,
                anioBusqueda: '',
            },
        }
        this.manejoEnvioConsulta = this.manejoEnvioConsulta.bind(this);
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejarAtras = this.manejarAtras.bind(this);
    }

    async componentDidMount(){
        const fech = new Date();
        this.setState({
            actual: fech.toISOString().substring(8,10) + '/' + fech.toISOString().substring(5,7) + '/' + fech.toISOString().substring(0,4)
        });
        this.setState(state => {
            const numFunActualizado = state.busqueda;
            numFunActualizado['hastaBusqueda'] = fech.toISOString().substring(0,10);
            numFunActualizado['anioBusqueda'] = fech.toISOString().substring(0,4);
            return{
                busqueda: numFunActualizado,
            };
        });
        const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_codigosMovimientos.php`);
        const datos = await respuesta.json();
        this.setState({
            codigosMovimientos: datos,
        });

        const lugar = await fetch(`${Constantes.RUTA_API}/obtener_lugaresTrabajo.php`);
        const datoLugar = await lugar.json();
        this.setState({
            lugaresTra: datoLugar,
        });


        const lugarCentral = await fetch(`${Constantes.RUTA_API}/obtener_ubicacionesCentral.php`);
        const datoLugarCentral = await lugarCentral.json();
        this.setState({
            ubicacionesCentral: datoLugarCentral,
        });
    }
    render(){
        return (
            <>
            <Container>
                <h3>Consulta Movimientos</h3>
                {this.state.loading
                ?
                    <div style={{placeItems: 'center'}}>
                        <Box sx={{alignItems: 'center'}}>
                            <CircularProgress/>
                        </Box>
                    </div>
                :
                    null
                }
                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                <br/>
                <div>
                {this.state.consulta ?
                    <ReactHtmlTableToExcel id="botonExportarExcel" className="btn btn-outline-success" table="tablaConsulta" filename="prueba" sheet="pagina 1" buttonText="Exportar a Excel">
                    </ReactHtmlTableToExcel> : null }
                </div>
                <br/>
                <TableContainer style={{width: '90%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                    <Table sx={{minWidth: 700}} id="tablaConsulta">
                        {this.state.consulta ? 
                            <TableHead>
                                {this.state.resCodEspecial ?
                                    this.state.busqueda.codigo === '1001' ?
                                    <TableRow>
                                            <StyledTableCell align="center" colSpan={5}>
                                                LICENCIA PENDIENTE DE {this.state.busqueda.anioBusqueda}
                                            </StyledTableCell>
                                    </TableRow>
                                : null : null}
                                {this.state.resCodEspecial ?
                                    this.state.busqueda.codigo === '1002' ?    
                                    <TableRow>
                                        <StyledTableCell align="center" colSpan={5}>
                                            ANTIGÜEDAD PENDIENTE DE {this.state.busqueda.anioBusqueda}
                                        </StyledTableCell>
                                    </TableRow>
                                : null : null}
                                {this.state.resCodEspecial ?
                                        this.state.busqueda.codigo === '1003' ?
                                    <TableRow>
                                            <StyledTableCell align="center" colSpan={5}>
                                                ACTA 1694 PENDIENTE
                                            </StyledTableCell>
                                    </TableRow>
                                : null : null}
                                {this.state.resCodEspecial ?
                                        this.state.busqueda.codigo === '1004' ?
                                    <TableRow>
                                            <StyledTableCell align="center" colSpan={6}>
                                                LICENCIA ANUAL PERIODO DESDE: {this.state.busqueda.desdeBusqueda.substring(8,10) + "/" + this.state.busqueda.desdeBusqueda.substring(5,7) + "/" + this.state.busqueda.desdeBusqueda.substring(0,4)} HASTA: {this.state.busqueda.hastaBusqueda.substring(8,10) + "/" + this.state.busqueda.hastaBusqueda.substring(5,7) + "/" + this.state.busqueda.hastaBusqueda.substring(0,4)}
                                            </StyledTableCell>
                                    </TableRow>
                                : null : null}
                                {this.state.resCodEspecial ? null :
                                    <TableRow>
                                            {/*Aca tengo que ver que tipo de consula es */}
                                            <StyledTableCell align="center" colSpan={6}>
                                                {this.state.tipoEncabezado}
                                            </StyledTableCell>
                                    </TableRow>
                                }
                                {/*----------------- La fecha la dejo siempre -------------------- */}
                                {this.state.resCodEspecial ?
                                    <TableRow>
                                            {this.state.busqueda.codigo !== '1004' ?
                                            <StyledTableCell align="center" colSpan={5}>
                                                Fecha Actual {this.state.actual}
                                            </StyledTableCell> : <StyledTableCell align="center" colSpan={6}>
                                                Fecha Actual {this.state.actual}
                                            </StyledTableCell>}
                                    </TableRow>
                                : null}
                            </TableHead>
                        : null}
                        <TableHead>
                            <TableRow>
                                {/*<StyledTableCell width={'16%'}>Consulta</StyledTableCell>*/}
                                {this.state.resCodEspecial ? <StyledTableCell width={'16%'}>Código</StyledTableCell> : <StyledTableCell width={'16%'}>Consulta</StyledTableCell>}
                                {this.state.consulta ? <StyledTableCell width={'16%'}>Número</StyledTableCell> : <StyledTableCell width={'16%'}>Número Funcionario</StyledTableCell> }
                                {this.state.consulta ? <StyledTableCell width={'16%'}>Nombre</StyledTableCell> : null }
                                {this.state.consulta ? null : <StyledTableCell width={'16%'}>Ubicación</StyledTableCell>}
                                {this.state.consulta ? null : this.state.busqueda.ubicacionBusqueda === '0' ? <StyledTableCell width={'16%'}>Ubicación Central</StyledTableCell> : null}
                                {this.state.anio ? <StyledTableCell width={'16%'}>Año</StyledTableCell> : null}
                                {this.state.resCodEspecial ? null : <StyledTableCell width={'16%'}>Desde</StyledTableCell>}
                                {this.state.resCodEspecial ? null : <StyledTableCell width={'16%'}>Hasta</StyledTableCell>}
                                {this.state.busqueda.codigo === '1004' ? this.state.resCodEspecial ? <StyledTableCell>Desde</StyledTableCell> : null : null}
                                {this.state.busqueda.codigo === '1004' ? this.state.resCodEspecial ? <StyledTableCell>Hasta</StyledTableCell> : null : null}
                                {this.state.consulta ? <StyledTableCell width={'16%'}>Cantidad</StyledTableCell> : null }
                                {this.state.consulta ? null : <StyledTableCell width={'16%'}></StyledTableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.resCodEspecial ?
                                this.state.busqueda.codigo === '1001' ?
                                    this.state.consultaRealizada.map((dato) => (
                                        <StyledTableRow key={dato.idDiasMovimiento}>
                                            {this.state.codigosMovimientos.map((name) => {
                                                if(name.idCodigoMovimiento === dato.codigo){
                                                    desc = name.descripcion;
                                                    if((dato.codigo === 28 || (dato.codigo === 46))){
                                                        dia = false;
                                                    }else{
                                                        dia = true;
                                                    }
                                                }
                                            })}
                                            <StyledTableCell>{desc}</StyledTableCell>
                                            <StyledTableCell>{dato.numeroFuncionario}</StyledTableCell>
                                            <StyledTableCell>{dato.primerNombre + ' ' + dato.primerApellido}</StyledTableCell>
                                            <StyledTableCell>{dato.anio}</StyledTableCell>
                                            {dia ? <StyledTableCell>{dato.diasDisponibles} días</StyledTableCell> : null}
                                            {dia ? null :<StyledTableCell>{dato.horasDisponibles} minutos</StyledTableCell> }
                                    </StyledTableRow>
                                    ))
                                :
                                this.state.busqueda.codigo === '1002' ?
                                    this.state.consultaRealizada.map((dato) => (
                                        <StyledTableRow key={dato.idDiasMovimiento}>
                                            {this.state.codigosMovimientos.map((name) => {
                                                if(name.idCodigoMovimiento === dato.codigo){
                                                    desc = name.descripcion;
                                                    if((dato.codigo === 28 || (dato.codigo === 46))){
                                                        dia = false;
                                                    }else{
                                                        dia = true;
                                                    }
                                                }
                                            })}
                                            <StyledTableCell>{desc}</StyledTableCell>
                                            <StyledTableCell>{dato.numeroFuncionario}</StyledTableCell>
                                            <StyledTableCell>{dato.primerNombre + ' ' + dato.primerApellido}</StyledTableCell>
                                            <StyledTableCell>{dato.anio}</StyledTableCell>
                                            {dia ? <StyledTableCell>{dato.diasDisponibles} días</StyledTableCell> : null}
                                            {dia ? null :<StyledTableCell>{dato.horasDisponibles} minutos</StyledTableCell> }
                                    </StyledTableRow>
                                    ))
                                :
                                this.state.busqueda.codigo === '1004' ?
                                    this.state.consultaRealizada.map((dato) => (
                                        <StyledTableRow key={dato.idMovimiento}>
                                            {this.state.codigosMovimientos.map((name) => {
                                                if(name.idCodigoMovimiento === dato.codigo){
                                                    desc = name.descripcion;
                                                    if((dato.codigo === 28 || (dato.codigo === 46))){
                                                        dia = false;
                                                    }else{
                                                        dia = true;
                                                    }
                                                }
                                            })}
                                            <StyledTableCell>{desc}</StyledTableCell>
                                            <StyledTableCell>{dato.numeroFuncionario}</StyledTableCell>
                                            <StyledTableCell>{dato.nombreFuncionario}</StyledTableCell>
                                            <StyledTableCell>{ dato.desde.substring(8,10) + '/' + dato.desde.substring(5,7) + '/' + dato.desde.substring(0,4)}</StyledTableCell>
                                            <StyledTableCell>{ dato.hasta.substring(8,10) + '/' + dato.hasta.substring(5,7) + '/' + dato.hasta.substring(0,4)}</StyledTableCell>
                                            {dia ? <StyledTableCell>{dato.dias} días</StyledTableCell> : null}
                                            {dia ? null :<StyledTableCell>{dato.minutos} minutos</StyledTableCell> }
                                    </StyledTableRow>
                                    ))
                                :
                                this.state.consultaRealizada.map((dato) => (
                                    <StyledTableRow key={dato.idHorasDiasGenerados}>
                                        {this.state.codigosMovimientos.map((name) => {
                                            if(name.idCodigoMovimiento === dato.codigo){
                                                desc = name.descripcion;
                                                if((dato.codigo === 28)){
                                                    dia = false;
                                                }else{
                                                    dia = true;
                                                }
                                            }
                                        })}
                                        <StyledTableCell>{desc}</StyledTableCell>
                                        <StyledTableCell>{dato.numeroFuncionario}</StyledTableCell>
                                        <StyledTableCell>{dato.primerNombre + ' ' + dato.primerApellido}</StyledTableCell>
                                        {dia ? <StyledTableCell>{dato.diasTotal} días</StyledTableCell> : null}
                                        {dia ? null :<StyledTableCell>{dato.horasTotal} minutos</StyledTableCell> }
                                </StyledTableRow>
                                ))
                            :
                                this.state.consultaRealizada.map((dato) => (
                                    <StyledTableRow key={dato.idMovimiento}>
                                        {this.state.codigosMovimientos.map((name) => {
                                            if(name.idCodigoMovimiento === dato.codigo){
                                                desc = name.descripcion;
                                                if((dato.codigo === 28 || (dato.codigo === 46))){
                                                    if(dato.dias === 0){
                                                        dia = false;
                                                    }else{
                                                        dia = true;
                                                    }
                                                }else{
                                                    dia = true;
                                                }
                                            }
                                        })}
                                        <StyledTableCell>{desc}</StyledTableCell>
                                        <StyledTableCell>{dato.numeroFuncionario}</StyledTableCell>
                                        <StyledTableCell>{dato.nombreFuncionario}</StyledTableCell>
                                        <StyledTableCell>{ dato.desde.substring(8,10) + '/' + dato.desde.substring(5,7) + '/' + dato.desde.substring(0,4)}</StyledTableCell>
                                        <StyledTableCell>{ dato.hasta.substring(8,10) + '/' + dato.hasta.substring(5,7) + '/' + dato.hasta.substring(0,4)}</StyledTableCell>
                                        {dia ? <StyledTableCell>{dato.dias} días</StyledTableCell> : null}
                                        {dia ? null :<StyledTableCell>{dato.minutos} minutos</StyledTableCell> }
                                </StyledTableRow>
                                ))
                            }
                            {this.state.consulta ? null :
                                <StyledTableRow>
                                    <StyledTableCell>
                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='codigo'  value={this.state.busqueda.codigo} onChange={this.manejarCambiosDatos}>
                                            <option value=''>CONSULTA</option>
                                            <option value={1000} key={1000}>HORAS Y DÍAS INHÁBILES PENDIENTES</option>
                                            <option value={1001} key={1001}>LICENCIA PENDIENTE</option>
                                            <option value={1002} key={1002}>ANTIGÜEDAD PENDIENTE</option>
                                            <option value={1003} key={1003}>ACTA 1694 PENDIENTE</option>
                                            <option value={1004} key={1004}>LICENCIA ANUAL</option>
                                            <option value='--'>------------------------------------------------------------</option>
                                            {this.state.codigosMovimientos.map((name) =>
                                                <option
                                                key={name.idCodigoMovimiento}
                                                value={name.idCodigoMovimiento}
                                                >{name.descripcion}</option>
                                                )}
                                        </select>
                                    </StyledTableCell>
                                    <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='numeroFuncionarioBusqueda' value={this.state.busqueda.numeroFuncionarioBusqueda} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                    <StyledTableCell>
                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='ubicacionBusqueda'  value={this.state.busqueda.ubicacionBusqueda} onChange={this.manejarCambiosDatos}>
                                            <option value=''>UBICACION</option>
                                            {this.state.lugaresTra.map((name) =>
                                                <option
                                                key={name.idLugaresTrabajo}
                                                value={name.idLugaresTrabajo}
                                                >{name.lugar}</option>
                                                )}
                                        </select>
                                    </StyledTableCell>
                                    {this.state.busqueda.ubicacionBusqueda === '0' ?
                                        <StyledTableCell>
                                            <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='ubicacionCentral'  value={this.state.busqueda.ubicacionCentral} onChange={this.manejarCambiosDatos}>
                                                <option value=''>UBICACION</option>
                                                {this.state.ubicacionesCentral.map((name) =>
                                                    <option
                                                    key={name.idUbicacionesCentral}
                                                    value={name.idUbicacionesCentral}
                                                    >{name.descripcion}
                                                </option>
                                                    )}
                                            </select>
                                        </StyledTableCell> : null
                                    }
                                    {this.state.anio ? <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='anioBusqueda' value={this.state.busqueda.anioBusqueda} onChange={this.manejarCambiosDatos}/></StyledTableCell> : null}
                                    {this.state.busqueda.codEspeciales ? <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='desdeBusqueda' value={this.state.busqueda.desdeBusqueda} onChange={this.manejarCambiosDatos}/></StyledTableCell> : this.state.busqueda.codigo === '1004' ? null : <StyledTableCell></StyledTableCell>}
                                    {this.state.busqueda.codEspeciales ? <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='hastaBusqueda' value={this.state.busqueda.hastaBusqueda} onChange={this.manejarCambiosDatos}/></StyledTableCell> : this.state.busqueda.codigo === '1004' ? null : <StyledTableCell></StyledTableCell>}
                                    {this.state.busqueda.codigo === '1004' ? <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='desdeBusqueda' value={this.state.busqueda.desdeBusqueda} onChange={this.manejarCambiosDatos}/></StyledTableCell> : null}
                                    {this.state.busqueda.codigo === '1004' ? <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='hastaBusqueda' value={this.state.busqueda.hastaBusqueda} onChange={this.manejarCambiosDatos}/></StyledTableCell> : null}
                                    <StyledTableCell><button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejoEnvioConsulta()}>Consultar</button></StyledTableCell>
                                </StyledTableRow>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                {this.state.consulta ? <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtras}>Volver</button> : null }
            </Container>
            </>
        )//Final return
    }//Final render

    async manejoEnvioConsulta(){
        this.setState({
            errores: null,
            loading: true,
        });
        //Realizo la consulta
        const cargaUtil = JSON.stringify(this.state.busqueda);

        const respuesta = await fetch(`${Constantes.RUTA_API}/consultar_movimientos.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();

        this.setState({
            loading: false,
        })

        //----------------------------------
        let tipC = '';
        {this.state.codigosMovimientos.map((name) => {
            let val = parseFloat(this.state.busqueda.codigo);
            if(name.idCodigoMovimiento === val){
                tipC = name.descripcion;
            }
        })}

        let ubiCentral = '';
        {this.state.ubicacionesCentral.map((name) => {
            let val = parseFloat(this.state.busqueda.ubicacionCentral);
            if(name.idUbicacionesCentral === val){
                ubiCentral = name.descripcion;
            }
        })}

        let ubi = '';
        {this.state.lugaresTra.map((name) => {
            let val = parseFloat(this.state.busqueda.ubicacionBusqueda);
            if(name.idLugaresTrabajo === val){
                ubi = name.lugar;
            }
        })}
        //----------------------------------
        if(exito.length !== 0){
            if((this.state.busqueda.codigo == '') && (this.state.busqueda.numeroFuncionarioBusqueda == '') && (this.state.busqueda.ubicacionBusqueda == '') && (this.state.busqueda.desdeBusqueda == '')){
                this.setState({
                    tipoEncabezado: 'LISTADO MOVIMIENTOS GENERALES TODOS LOS FUNCIONARIOS',
                });
            }else if((this.state.busqueda.codigo != '') && (this.state.busqueda.numeroFuncionarioBusqueda == '') && (this.state.busqueda.ubicacionBusqueda == '') && (this.state.busqueda.desdeBusqueda == '')){
                this.setState({
                    tipoEncabezado: 'LISTADO MOVIMIENTOS ' + tipC + ' TODOS LOS FUNCIONARIOS',
                });
            }else if((this.state.busqueda.codigo == '') && (this.state.busqueda.numeroFuncionarioBusqueda != '') && (this.state.busqueda.ubicacionBusqueda == '') && (this.state.busqueda.desdeBusqueda == '')){
                this.setState({
                    tipoEncabezado: 'LISTADO MOVIMIENTOS GENERALES FUNCIONARIO ' + this.state.busqueda.numeroFuncionarioBusqueda,
                });
            }else if((this.state.busqueda.codigo == '') && (this.state.busqueda.numeroFuncionarioBusqueda == '') && (this.state.busqueda.ubicacionBusqueda != '') && (this.state.busqueda.desdeBusqueda == '')){
                this.setState({
                    tipoEncabezado: 'LISTADO MOVIMIENTOS TODOS LOS FUNCIONARIOS UBICACION ' + ubi + ' ' + ubiCentral,
                });
            }else if((this.state.busqueda.codigo == '') && (this.state.busqueda.numeroFuncionarioBusqueda == '') && (this.state.busqueda.ubicacionBusqueda == '') && (this.state.busqueda.desdeBusqueda != '')){
                this.setState({
                    tipoEncabezado: 'LISTADO MOVIMIENTOS TODOS LOS FUNCIONARIOS DESDE ' + this.state.busqueda.desdeBusqueda.substring(8,10) + "/" + this.state.busqueda.desdeBusqueda.substring(5,7) + "/" + this.state.busqueda.desdeBusqueda.substring(0,4) + ' HASTA ' + this.state.busqueda.hastaBusqueda.substring(8,10) + "/" + this.state.busqueda.hastaBusqueda.substring(5,7) + "/" + this.state.busqueda.hastaBusqueda.substring(0,4),
                });
            }else if((this.state.busqueda.codigo != '') && (this.state.busqueda.numeroFuncionarioBusqueda != '') && (this.state.busqueda.ubicacionBusqueda == '') && (this.state.busqueda.desdeBusqueda == '')){
                this.setState({
                    tipoEncabezado: 'LISTADO MOVIMIENTOS ' + tipC + ' FUNCIONARIO ' + this.state.busqueda.numeroFuncionarioBusqueda,
                });
            }else if((this.state.busqueda.codigo != '') && (this.state.busqueda.numeroFuncionarioBusqueda == '') && (this.state.busqueda.ubicacionBusqueda != '') && (this.state.busqueda.desdeBusqueda == '')){
                this.setState({
                    tipoEncabezado: 'LISTADO MOVIMIENTOS ' + tipC + ' TODOS LOS FUNCIONARIOS UBICACION ' + ubi + ' ' + ubiCentral,
                });
            }else if((this.state.busqueda.codigo != '') && (this.state.busqueda.numeroFuncionarioBusqueda == '') && (this.state.busqueda.ubicacionBusqueda == '') && (this.state.busqueda.desdeBusqueda != '')){
                this.setState({
                    tipoEncabezado: 'LISTADO MOVIMIENTOS ' + tipC + ' TODOS LOS FUNCIONARIOS DESDE ' + this.state.busqueda.desdeBusqueda.substring(8,10) + "/" + this.state.busqueda.desdeBusqueda.substring(5,7) + "/" + this.state.busqueda.desdeBusqueda.substring(0,4) + ' HASTA ' + this.state.busqueda.hastaBusqueda.substring(8,10) + "/" + this.state.busqueda.hastaBusqueda.substring(5,7) + "/" + this.state.busqueda.hastaBusqueda.substring(0,4),
                });
            }else if((this.state.busqueda.codigo != '') && (this.state.busqueda.numeroFuncionarioBusqueda != '') && (this.state.busqueda.ubicacionBusqueda != '') && (this.state.busqueda.desdeBusqueda == '')){
                this.setState({
                    tipoEncabezado: 'LISTADO MOVIMIENTOS ' + tipC + ' FUNCIONARIO ' + this.state.busqueda.numeroFuncionarioBusqueda + ' UBICACION ' + ubi + ' ' + ubiCentral,
                });
            }else if((this.state.busqueda.codigo != '') && (this.state.busqueda.numeroFuncionarioBusqueda != '') && (this.state.busqueda.ubicacionBusqueda != '') && (this.state.busqueda.desdeBusqueda != '')){
                this.setState({
                    tipoEncabezado: 'LISTADO MOVIMIENTOS ' + tipC + ' FUNCIONARIO ' + this.state.busqueda.numeroFuncionarioBusqueda + ' UBICACION ' + ubi + ' ' + ubiCentral + ' DESDE ' + this.state.busqueda.desdeBusqueda.substring(8,10) + "/" + this.state.busqueda.desdeBusqueda.substring(5,7) + "/" + this.state.busqueda.desdeBusqueda.substring(0,4) + ' HASTA ' + this.state.busqueda.hastaBusqueda.substring(8,10) + "/" + this.state.busqueda.hastaBusqueda.substring(5,7) + "/" + this.state.busqueda.hastaBusqueda.substring(0,4),
                });
            }else if((this.state.busqueda.codigo == '') && (this.state.busqueda.numeroFuncionarioBusqueda != '') && (this.state.busqueda.ubicacionBusqueda != '') && (this.state.busqueda.desdeBusqueda == '')){
                this.setState({
                    tipoEncabezado: 'LISTADO MOVIMIENTOS GENERALES FUNCIONARIO ' + this.state.busqueda.numeroFuncionarioBusqueda + ' UBICACION ' + ubi + ' ' + ubiCentral,
                });
            }else if((this.state.busqueda.codigo == '') && (this.state.busqueda.numeroFuncionarioBusqueda != '') && (this.state.busqueda.ubicacionBusqueda != '') && (this.state.busqueda.desdeBusqueda != '')){
                this.setState({
                    tipoEncabezado: 'LISTADO MOVIMIENTOS GENERALES FUNCIONARIO ' + this.state.busqueda.numeroFuncionarioBusqueda + ' UBICACION ' + ubi + ' ' + ubiCentral + ' DESDE ' + this.state.busqueda.desdeBusqueda.substring(8,10) + "/" + this.state.busqueda.desdeBusqueda.substring(5,7) + "/" + this.state.busqueda.desdeBusqueda.substring(0,4) + ' HASTA ' + this.state.busqueda.hastaBusqueda.substring(8,10) + "/" + this.state.busqueda.hastaBusqueda.substring(5,7) + "/" + this.state.busqueda.hastaBusqueda.substring(0,4),
                });
            }else if((this.state.busqueda.codigo == '') && (this.state.busqueda.numeroFuncionarioBusqueda == '') && (this.state.busqueda.ubicacionBusqueda != '') && (this.state.busqueda.desdeBusqueda != '')){
                this.setState({
                    tipoEncabezado: 'LISTADO MOVIMIENTOS GENERALES TODOS LOS FUNCIONARIOS UBICACION ' + ubi + ' ' + ubiCentral + ' DESDE ' + this.state.busqueda.desdeBusqueda.substring(8,10) + "/" + this.state.busqueda.desdeBusqueda.substring(5,7) + "/" + this.state.busqueda.desdeBusqueda.substring(0,4) + ' HASTA ' + this.state.busqueda.hastaBusqueda.substring(8,10) + "/" + this.state.busqueda.hastaBusqueda.substring(5,7) + "/" + this.state.busqueda.hastaBusqueda.substring(0,4),
                });
            }else if((this.state.busqueda.codigo == '') && (this.state.busqueda.numeroFuncionarioBusqueda != '') && (this.state.busqueda.ubicacionBusqueda == '') && (this.state.busqueda.desdeBusqueda != '')){
                this.setState({
                    tipoEncabezado: 'LISTADO MOVIMIENTOS GENERALES FUNCIONARIO ' + this.state.busqueda.numeroFuncionarioBusqueda + ' DESDE ' + this.state.busqueda.desdeBusqueda.substring(8,10) + "/" + this.state.busqueda.desdeBusqueda.substring(5,7) + "/" + this.state.busqueda.desdeBusqueda.substring(0,4) + ' HASTA ' + this.state.busqueda.hastaBusqueda.substring(8,10) + "/" + this.state.busqueda.hastaBusqueda.substring(5,7) + "/" + this.state.busqueda.hastaBusqueda.substring(0,4),
                });
            }else if((this.state.busqueda.codigo != '') && (this.state.busqueda.numeroFuncionarioBusqueda == '') && (this.state.busqueda.ubicacionBusqueda != '') && (this.state.busqueda.desdeBusqueda != '')){
                this.setState({
                    tipoEncabezado: 'LISTADO MOVIMIENTOS ' + tipC + ' TODOS LOS FUNCIONARIOS' + ' UBICACION ' + ubi + ' ' + ubiCentral + ' DESDE ' + this.state.busqueda.desdeBusqueda.substring(8,10) + "/" + this.state.busqueda.desdeBusqueda.substring(5,7) + "/" + this.state.busqueda.desdeBusqueda.substring(0,4) + ' HASTA ' + this.state.busqueda.hastaBusqueda.substring(8,10) + "/" + this.state.busqueda.hastaBusqueda.substring(5,7) + "/" + this.state.busqueda.hastaBusqueda.substring(0,4),
                });
            }else if((this.state.busqueda.codigo != '') && (this.state.busqueda.numeroFuncionarioBusqueda != '') && (this.state.busqueda.ubicacionBusqueda == '') && (this.state.busqueda.desdeBusqueda != '')){
                this.setState({
                    tipoEncabezado: 'LISTADO MOVIMIENTOS ' + tipC + ' FUNCIONARIO ' + this.state.busqueda.numeroFuncionarioBusqueda + ' DESDE ' + this.state.busqueda.desdeBusqueda.substring(8,10) + "/" + this.state.busqueda.desdeBusqueda.substring(5,7) + "/" + this.state.busqueda.desdeBusqueda.substring(0,4) + ' HASTA ' + this.state.busqueda.hastaBusqueda.substring(8,10) + "/" + this.state.busqueda.hastaBusqueda.substring(5,7) + "/" + this.state.busqueda.hastaBusqueda.substring(0,4),
                });
            }
            this.setState({
                consultaRealizada: exito,
                errores: null,
                notificaciones: null,
                consulta: true,
                //resCodEspecial: true,
            });
            if((this.state.busqueda.codigo === '1000') || (this.state.busqueda.codigo === '1001') || (this.state.busqueda.codigo === '1002') || (this.state.busqueda.codigo === '1003') || (this.state.busqueda.codigo === '1004')){
                this.setState({
                    resCodEspecial: true,
                });
            }
        }else{
            const fech = new Date();
            this.setState({
                resCodEspecial: false,
                anio: false,
                consulta: false,
                consultaRealizada: [],
                errores: 'No hay datos para la consulta realizada!',
                busqueda: {
                    consulta: '',
                    numeroFuncionarioBusqueda: '',
                    codigo: '',
                    ubicacionBusqueda: '',
                    desdeBusqueda: '',
                    hastaBusqueda: fech.toISOString().substring(0,10),
                    ubicacionCentral: '',
                    codEspeciales: true,
                    anioBusqueda: fech.toISOString().substring(0,4),
                },
            });
        }
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
        });
        if(clave === 'codigo'){
            if((valor === '1001') || (valor === '1002')){
                this.setState({
                    anio: true,
                });
            }else{
                this.setState({
                    anio: false,
                });
            }
        }
        this.setState(state => {
            const numFunActualizado = state.busqueda;
            numFunActualizado[clave] = valor;
            
            if(clave === 'ubicacionBusqueda'){
                if(valor !== '0'){
                    numFunActualizado['ubicacionCentral'] = '';
                }
            }else if(clave === 'codigo'){
                if((valor === '1000') || (valor === '1001') || (valor === '1002') || (valor === '1003') || (valor === '1004')){
                    numFunActualizado['codEspeciales'] = false;
                }else{
                    numFunActualizado['codEspeciales'] = true;
                }
            }
            return{
                busqueda: numFunActualizado,
            };
        });
    }

    manejarAtras(e){
        e.preventDefault();
        const fech = new Date();
        this.setState({
            consulta: false,
            anio: false,
            consultaRealizada: [],
            errores: null,
            notificaciones: null,
            resCodEspecial: false,
            busqueda: {
                consulta: '',
                numeroFuncionarioBusqueda: '',
                codigo: '',
                ubicacionBusqueda: '',
                desdeBusqueda: '',
                hastaBusqueda: fech.toISOString().substring(0,10),
                ubicacionCentral: '',
                codEspeciales: true,
                anioBusqueda: fech.toISOString().substring(0,4),
            },
        });
    }
}

export default ConsultaMovimientos